import { render, staticRenderFns } from "./TrafficStatisticTable.vue?vue&type=template&id=13d8857a&"
import script from "./TrafficStatisticTable.vue?vue&type=script&lang=js&"
export * from "./TrafficStatisticTable.vue?vue&type=script&lang=js&"
import style0 from "./TrafficStatisticTable.vue?vue&type=style&index=0&id=13d8857a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports